import React, { useState } from 'react';
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ClipboardList, Wallet, Timer, Star } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
import { KpiCard } from '../components/common/KpiCard';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Label } from '../components/ui/Label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/Select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { ordersByHour, earningsByDay, earningsByCategory, topDrivers } from '../data/analytics';
import { drivers } from '../data/drivers';
import { formatNumber, formatTmt } from '../utils/format';
const pieColors = ['var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)'];
export function Analytics() {
  const [from, setFrom] = useState('2026-07-28');
  const [to, setTo] = useState('2026-08-04');
  const [driver, setDriver] = useState('all');
  const totalEarnings = earningsByCategory.reduce((s, c) => s + c.value, 0);
  return <div data-id="element-158" data-mp="3nhwz4m79fkg6">
      <PageHeader title="Аналитика" description="Показатели автопарка за выбранный период" data-id="element-159" data-mp="3ne975rhgr63k" />

      <Card className="mb-4" data-id="element-160" data-mp="3rg4i7np74xuj">
        <CardContent className="flex flex-wrap items-end gap-3 p-4" data-id="element-161" data-mp="bmm92f5i993">
          <div className="space-y-1.5" data-id="element-162" data-mp="9tfln4jfp13">
            <Label htmlFor="from" data-id="element-163" data-mp="52cpoa40o215">Дата с</Label>
            <Input id="from" type="date" value={from} onChange={e => setFrom(e.target.value)} className="w-[170px]" data-id="element-164" data-mp="53eah6au42w2" />
          </div>
          <div className="space-y-1.5" data-id="element-165" data-mp="f12aobr7m2lm">
            <Label htmlFor="to" data-id="element-166" data-mp="f23im7cxi8z4">Дата по</Label>
            <Input id="to" type="date" value={to} onChange={e => setTo(e.target.value)} className="w-[170px]" data-id="element-167" data-mp="j2drbrs3vdho" />
          </div>
          <div className="space-y-1.5" data-id="element-168" data-mp="2g28k0900ec5j">
            <Label htmlFor="driver-filter" data-id="element-169" data-mp="2g39ti91dmql5">Водитель</Label>
            <Select value={driver} onValueChange={setDriver} data-id="element-170" data-mp="2b4q8caulxitu">
              <SelectTrigger id="driver-filter" className="w-[230px]" data-id="element-171" data-mp="2ovbr7zk29srq">
                <SelectValue placeholder="Все водители" data-id="element-172" data-mp="2owmwk3t5n8ky" />
              </SelectTrigger>
              <SelectContent data-id="element-173" data-mp="2k326qz1ptkwu">
                <SelectItem value="all" data-id="element-174" data-mp="2k2scv0djutlv">Все водители</SelectItem>
                {drivers.map(d => <SelectItem key={d.id} value={d.id} data-id="element-175" data-mp="2tuey7pjlq92c">
                    {d.name}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <Button className="ml-auto" data-id="element-176" data-mp="37rv2ovic7srg">Применить фильтры</Button>
          <Button variant="outline" data-id="element-177" data-mp="33t46qrplyh5x">Экспорт в CSV</Button>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-178" data-mp="1dgy8f94603ik">
        <KpiCard title="Заказов за период" value={formatNumber(1284)} hint="к прошлой неделе" delta={9} icon={ClipboardList} tone="blue" data-id="element-179" data-mp="19fd0m26hmff8" />
        <KpiCard title="Выручка за период" value={formatTmt(totalEarnings)} hint="к прошлой неделе" delta={14} icon={Wallet} tone="green" data-id="element-180" data-mp="zbg1wnau3ioe" />
        <KpiCard title="Среднее время подачи" value="6,4 мин" hint="к прошлой неделе" delta={-4} icon={Timer} tone="amber" data-id="element-181" data-mp="pl37829b294j" />
        <KpiCard title="Средний рейтинг" value="4,82" hint="по всем поездкам" delta={2} icon={Star} tone="slate" data-id="element-182" data-mp="uiweyzq9bb6x" />
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 xl:grid-cols-3" data-id="element-183" data-mp="flcdw3whe061">
        <Card className="xl:col-span-2" data-id="element-184" data-mp="km0cpbqyblat">
          <CardHeader className="pb-3" data-id="element-185" data-mp="kjnmyceyc6n7">
            <CardTitle className="text-base" data-id="element-186" data-mp="6mik0lajbnw6">Заказы по времени суток</CardTitle>
          </CardHeader>
          <CardContent className="h-[300px] p-3 pt-0" data-id="element-187" data-mp="bkk499jp5t98">
            <ResponsiveContainer width="100%" height="100%" data-id="element-188" data-mp="bn6c7aai2arz">
              <LineChart data={ordersByHour} margin={{
              top: 10,
              right: 12,
              left: -12,
              bottom: 0
            }} data-id="element-189" data-mp="2111pmwqdi7if">
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-190" data-mp="25y1revg6wo3q" />
                <XAxis dataKey="hour" tick={{
                fontSize: 12,
                fill: 'var(--muted-foreground)'
              }} tickLine={false} axisLine={false} data-id="element-191" data-mp="5vslbiwdl5q2" />
                <YAxis tick={{
                fontSize: 12,
                fill: 'var(--muted-foreground)'
              }} tickLine={false} axisLine={false} data-id="element-192" data-mp="yjxb1ojq7gw" />
                <Tooltip contentStyle={{
                borderRadius: 10,
                border: '1px solid var(--border)',
                background: 'var(--popover)',
                fontSize: 12
              }} data-id="element-193" data-mp="3s5wkbxc41f4q" />
                <Legend wrapperStyle={{
                fontSize: 12
              }} data-id="element-194" data-mp="3ebc9i3i6vxy9" />
                <Line type="monotone" dataKey="заказы" stroke="var(--chart-1)" strokeWidth={2.5} dot={false} data-id="element-195" data-mp="39d0w5isor5ba" />
                <Line type="monotone" dataKey="выполнено" stroke="var(--chart-2)" strokeWidth={2.5} dot={false} data-id="element-196" data-mp="34fiodvqemw4v" />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card data-id="element-197" data-mp="2vf41irxsl8z9">
          <CardHeader className="pb-3" data-id="element-198" data-mp="2veazu5dox9nz">
            <CardTitle className="text-base" data-id="element-199" data-mp="1aw0jslnhrzqi">Разбивка заработка</CardTitle>
          </CardHeader>
          <CardContent className="h-[300px] p-3 pt-0" data-id="element-200" data-mp="1futphrwjemg4">
            <ResponsiveContainer width="100%" height="100%" data-id="element-201" data-mp="1fta6htjhxxan">
              <PieChart data-id="element-202" data-mp="1jvwzhxrwlo9f">
                <Pie data={earningsByCategory} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={2} data-id="element-203" data-mp="1jxqa1o5n0smp">
                  {earningsByCategory.map((entry, i) => <Cell key={entry.name} fill={pieColors[i % pieColors.length]} data-id="element-204" data-mp="s6ahldhegbok" data-mpi={i} />)}
                </Pie>
                <Tooltip formatter={(value: number) => formatTmt(value)} contentStyle={{
                borderRadius: 10,
                border: '1px solid var(--border)',
                background: 'var(--popover)',
                fontSize: 12
              }} data-id="element-205" data-mp="w740ttjwd2b4" />
                <Legend wrapperStyle={{
                fontSize: 12
              }} data-id="element-206" data-mp="dg36jitq1uxw" />
              </PieChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 xl:grid-cols-3" data-id="element-207" data-mp="1gp5vbz8m7wng">
        <Card className="xl:col-span-1" data-id="element-208" data-mp="1bre4z9nmcild">
          <CardHeader className="pb-3" data-id="element-209" data-mp="1bqcryzn1lm10">
            <CardTitle className="text-base" data-id="element-210" data-mp="1pju25ttu9med">Заработок по дням недели</CardTitle>
          </CardHeader>
          <CardContent className="h-[300px] p-3 pt-0" data-id="element-211" data-mp="1lhqpj1vfobri">
            <ResponsiveContainer width="100%" height="100%" data-id="element-212" data-mp="1lkcvwy6l8l85">
              <BarChart data={earningsByDay} margin={{
              top: 10,
              right: 12,
              left: -12,
              bottom: 0
            }} data-id="element-213" data-mp="xt7i0ok7k30h">
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-214" data-mp="suw524ym9ce1" />
                <XAxis dataKey="day" tick={{
                fontSize: 12,
                fill: 'var(--muted-foreground)'
              }} tickLine={false} axisLine={false} data-id="element-215" data-mp="16tvsxaeb1n95" />
                <YAxis tick={{
                fontSize: 12,
                fill: 'var(--muted-foreground)'
              }} tickLine={false} axisLine={false} data-id="element-216" data-mp="11w3zgby0ht2u" />
                <Tooltip formatter={(value: number) => formatTmt(value)} contentStyle={{
                borderRadius: 10,
                border: '1px solid var(--border)',
                background: 'var(--popover)',
                fontSize: 12
              }} data-id="element-217" data-mp="2d96hzcjo8spn" />
                <Bar dataKey="заработок" fill="var(--chart-1)" radius={[6, 6, 0, 0]} data-id="element-218" data-mp="2bt138czhgsxd" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card className="xl:col-span-2" data-id="element-219" data-mp="34gesdowxwk6x">
          <CardHeader className="pb-3" data-id="element-220" data-mp="34hgfirr8cx50">
            <CardTitle className="text-base" data-id="element-221" data-mp="39fhxtagu0sff">Лучшие водители за период</CardTitle>
          </CardHeader>
          <CardContent className="p-0" data-id="element-222" data-mp="2urddy361mav2">
            <Table data-id="element-223" data-mp="2uqc1bu9dpgb8">
              <TableHeader data-id="element-224" data-mp="2uor5m1bbvrbs">
                <TableRow data-id="element-225" data-mp="2zpopcibzktfe">
                  <TableHead className="w-12" data-id="element-226" data-mp="2zowrf0ux2jly">#</TableHead>
                  <TableHead data-id="element-227" data-mp="3nfiz2r10e1vf">Водитель</TableHead>
                  <TableHead className="text-right" data-id="element-228" data-mp="3ner33f3i224m">Заказов</TableHead>
                  <TableHead className="text-right" data-id="element-229" data-mp="3s6rafslwfxb8">Заработок</TableHead>
                  <TableHead className="text-right" data-id="element-230" data-mp="3s829xg8baiwj">Рейтинг</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-231" data-mp="1ncrhxbpvi0ps">
                {topDrivers.map((d, i) => <TableRow key={d.name} data-id="element-232" data-mp="1nbgj7qbabj5j" data-mpi={i}>
                    <TableCell className="text-muted-foreground" data-id="element-233" data-mp="1if876lsdw62l">{i + 1}</TableCell>
                    <TableCell className="font-medium text-foreground" data-id="element-234" data-mp="1ed4r1jursdaz">{d.name}</TableCell>
                    <TableCell className="text-right" data-id="element-235" data-mp="2b2lyo4dbc9fb">{d.trips}</TableCell>
                    <TableCell className="text-right font-medium" data-id="element-236" data-mp="2b0hsffrxyybv">{formatTmt(d.earnings)}</TableCell>
                    <TableCell className="text-right" data-id="element-237" data-mp="261y81jszxulm">
                      <span className="inline-flex items-center gap-1" data-id="element-238" data-mp="220up2ofnjig6">
                        <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-239" data-mp="1x3m9mvlw1sim" />
                        {d.rating.toFixed(1)}
                      </span>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>;
}